import { parse, stringify } from 'querystring';
import { useQuery } from '@apollo/client';
import { TurboQuery } from '@catalogo/core-types';
import { Turbo } from '../queries/turbo.graphql';

export const useQueryTurbo = (pathname = '', search = '', source = '') => {
  const qs = parse(search.replace('?', ''));
  if (source) {
    qs['source'] = source;
  }
  const allowedList = ['conteudo', 'context', 'chave_search', 'suggestion', 'filter', 'source', 'origem'];
  const filtered = Object.entries(qs).filter(([key]) => allowedList.includes(key));
  const newSearch = filtered.length ? `?${stringify(Object.fromEntries(filtered))}` : '';

  const path = `${pathname}${newSearch}`;

  const { data, loading, error: turboError } = useQuery<TurboQuery>(Turbo, {
    variables: { path },
  });

  const redirectTo = data?.turbo?.redirectTo || null;
  const error = turboError || !data?.turbo;

  return { turboData: data?.turbo, redirectTo, loading, error };
};
